import DOMPurify from 'dompurify';
import { marked } from 'marked';

marked.setOptions({
  breaks: true,
  gfm: true,
});

const isExternalHref = (href) => {
  if (!href || typeof href !== 'string') {
    return false;
  }

  return /^(https?:)?\/\//i.test(href.trim());
};

// Open external links in a new tab; harden against reverse tabnabbing.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName !== 'A') {
    return;
  }

  const href = node.getAttribute('href') || '';
  const has_blank_target = node.getAttribute('target') === '_blank';

  if (!has_blank_target && !isExternalHref(href)) {
    return;
  }

  node.setAttribute('target', '_blank');

  const existing_rel = (node.getAttribute('rel') || '')
    .split(/\s+/)
    .filter(Boolean);
  const required_rel = ['noopener', 'noreferrer'];

  required_rel.forEach((token) => {
    if (!existing_rel.includes(token)) {
      existing_rel.push(token);
    }
  });

  node.setAttribute('rel', existing_rel.join(' '));
});

/**
 * Convert markdown to sanitized HTML safe for v-html.
 * @param {string} markdown
 * @returns {string}
 */
const renderMarkdown = (markdown) => {
  if (!markdown || typeof markdown !== 'string') {
    return '';
  }

  const html = marked.parse(markdown)
    .replace(/<table>/g, '<div class="chatbot-md-table"><table>')
    .replace(/<\/table>/g, '</table></div>');

  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target'],
  });
};

export {
  renderMarkdown,
};
